window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
};
window.gtag('js', new Date());
window.gtag('config', 'G-XT1ENJ6Z6M');

window._piq = window._piq || [];
window._piq.push(
    ['setCustomVar', 'venue', 'pixnet-event-2022chlitina-Visit'],
    ['setCustomVar', 'visitor_id', ''],
    ['trackPageView']
);

(function (d, t, u, f, j) {
    f = d.getElementsByTagName(t)[0];
    j = d.createElement(t);
    j.async = 1;
    j.src = u;
    f.parentNode.insertBefore(j, f);
})(document, 'script', '//s.pixanalytics.com/js/pi.min.js?v=1');
